import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_VENDOR } from './queries';
import { ButtonContainer } from './elements';
import secrets from '../../../secrets';

export const TAX_CLASSIFICATIONS = [
  "Sole Proprietor", "C corporation", "S corporation", "Partnership", "Trust", "LLC"
]

export const TAX_ID_TYPES = ["SSN", "EIN"]

const NewVendor = props => {
  const {
    setShowModal, refetch, fromNewExpense, setNewVendor, defaultName
  } = props;

  const [submitting, setSubmitting] = useState();
  const [createVendor] = useMutation(CREATE_VENDOR, {
    onCompleted: data => {
      if (refetch) { refetch(data); }
      if (fromNewExpense) {
        setNewVendor(data.createVendor.vendor)
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if (!input.taxClassification) { input.taxClassification = null; }
    if (!input.taxIdType) { input.taxIdType = null; }
    createVendor({ variables: input });
  });

  const { control, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      name: (defaultName || ''),
      street: '',
      city: '',
      state: '',
      postalCode: '',
      phoneNumber: '',
      email: '',
      taxClassification: '',
      llc: false,
      taxIdType: '',
      taxIdNumber: ''
    }
  });

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
            {...register("name", {
              required: "Required"
            })}
          />
          <Input.Text
            label="Street:"
            name="street"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="City:"
            name="city"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Zip:"
            name="postalCode"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Notes:"
            name="notes"
            control={control}
            errors={errors}
          />
          { secrets.app.doubleEntry &&
            <>

              <Input.Picker
                label="Tax Classification:"
                name="taxClassification"
                options={
                  TAX_CLASSIFICATIONS.map(type => { return { value: type, label: type }})
                }
                control={control}
                errors={errors}
              />
              <Input.Checkbox
                label="LLC:"
                name="llc"
                control={control}
                errors={errors}
              />
              <Input.Picker
                label="Tax ID Type:"
                name="taxIdType"
                options={
                  TAX_ID_TYPES.map(type => { return { value: type, label: type }})
                }
                control={control}
                errors={errors}
              />
              <Input.Text
                label="Tax ID Number"
                name="taxIdNumber"
                control={control}
                errors={errors}
              />
            </>
          }
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Vendor" onPress={handleSubmit(onSubmit)} />
              {fromNewExpense &&
                <Button label="Cancel" onPress={() => setShowModal(false)} />
              }
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewVendor;
